import { PaperPlaneSkyblue } from "components/icons/PaperPlaneSkyblue";
import { PlanCard } from "components/SubscriptionModal/PlanCard";
import { openMeetWithTranqModal } from "store/slices/chat";
import { useDispatch } from "react-redux";
import { Subscription } from "types/Models/subscription";
import { BOOKKEEPING_V2 } from "constants/addons";
import { INKLE_CONSULTATION } from "constants/meetingRequestUrls";
import { RocketPurpleAnimate } from "components/icons/RocketPurpleAnimate";
import { FlyingSaucerGreen } from "components/icons/FlyingSaucerGreen";

export type BooksServicesSubscriptionsContentProps = {
  bookkeepingPlusActivePlan?: Subscription;
  subscriptionPlans?: Subscription[];
  onManage?: (addon: Subscription) => void;
  hideAnualPlan?: boolean;
};

export const BooksServicesSubscriptionsContent = ({
  bookkeepingPlusActivePlan,
  subscriptionPlans,
  onManage,
  hideAnualPlan,
}: BooksServicesSubscriptionsContentProps) => {
  const dispatch = useDispatch();
  const anualServicePlanFeatures = [
    {
      description: "Annual Bookkeeper",
      active: true,
    },
    {
      description: "Chat",
      active: true,
    },
    {
      description: "Annual Review Call",
      active: true,
    },
    {
      description: "Annual Standard Financials",
      active: true,
    },
    {
      description: "Standard Chart of Accounts",
      active: true,
    },
    {
      description: "Cash Method (Accrual Method extra)",
      active: true,
    },
  ];
  return (
    <section className="t-flex t-gap-4">
      {!hideAnualPlan && (
        <PlanCard
          price={1}
          type="Annual"
          buttonText="Book a call"
          features={anualServicePlanFeatures}
          icon={<PaperPlaneSkyblue />}
          description="Annual catchup for low activity companies, to get ready for tax season"
          billingCycle="transaction"
          onUpgrade={() => dispatch(openMeetWithTranqModal(INKLE_CONSULTATION))}
        />
      )}
      {subscriptionPlans
        ?.filter(
          (item: Subscription) => item?.subscription_type === BOOKKEEPING_V2
        )
        ?.sort((a, b) => a.upgrade_level - b.upgrade_level)
        ?.map((plan: Subscription) => (
          <PlanCard
            key={plan.uuid}
            price={plan.amount}
            billingCycle="month"
            type={plan.subscription_name}
            buttonText={
              bookkeepingPlusActivePlan?.uuid === plan.uuid
                ? "Manage Subscription"
                : "Book a call"
            }
            features={plan.metadata?.comparison || []}
            icon={
              plan.upgrade_level! === 1 ? (
                <RocketPurpleAnimate />
              ) : (
                <FlyingSaucerGreen />
              )
            }
            description={plan.metadata?.service_description || ""}
            includeStartsFrom
            isMostPopular={plan.subscription_name === "Bookkeeping Monthly"}
            onUpgrade={() =>
              bookkeepingPlusActivePlan?.uuid === plan.uuid
                ? onManage && onManage(plan)
                : dispatch(openMeetWithTranqModal(INKLE_CONSULTATION))
            }
            buttonType={
              bookkeepingPlusActivePlan?.uuid === plan.uuid
                ? "secondary"
                : "primary-outlined"
            }
            isActive={bookkeepingPlusActivePlan?.uuid === plan.uuid}
          />
        ))}
    </section>
  );
};
